var map = {
	"./australia.png": 610,
	"./bahrain.png": 611,
	"./brazil.png": 612,
	"./canada.png": 613,
	"./china.png": 614,
	"./france.png": 615,
	"./germany.png": 616,
	"./india.png": 617,
	"./ireland.png": 618,
	"./japan.png": 619,
	"./singapore.png": 620,
	"./south-korea.png": 621,
	"./sweden.png": 622,
	"./uk.png": 623,
	"./usa.png": 624
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1363;